import React, { useCallback, useMemo } from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { LABEL_STYLE, LEGEND_STYLE, TOOLTIP_STYLE } from "@/lib/chartStyles";
import { num } from "@/lib/format";

export function Donut({ rows, colors, unit, testId }) {
  const data = useMemo(
    () => rows.filter((r) => !r.implausible && r.usage > 0).slice(0, 6).map((r) => ({ name: r.dis, value: r.usage })),
    [rows]
  );
  const format = useCallback((v) => `${num(v)} ${unit}`, [unit]);
  if (data.length === 0) return <div className="h-56 flex items-center justify-center text-sm text-[#9CA3AF]">No meter data</div>;
  return (
    <div className="h-56" data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={0}>
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" innerRadius="55%" outerRadius="80%" paddingAngle={2} stroke="none">
            {data.map((slice, i) => (
              <Cell key={slice.name} fill={colors[i % colors.length]} />
            ))}
          </Pie>
          <Tooltip contentStyle={TOOLTIP_STYLE} labelStyle={LABEL_STYLE} formatter={format} />
          <Legend verticalAlign="bottom" height={48} wrapperStyle={LEGEND_STYLE} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
